export default __webpack_public_path__ + "static/herobhm-3c71f4a18b0435ded1c8b505364419d4.jpg";